module.exports = __webpack_public_path__ + "ed67a5bcf0543cc334b57ad43f1426d0.png";